module.exports = __webpack_public_path__ + "img/especiales.ba825f9d.jpg";